import { Pipe, PipeTransform } from '@angular/core';
import {
  DprActivityCustomDataReport,
  DprActivityInlineCustomDataReport,
} from '@report/models';

@Pipe({
  name: 'hasCustomData',
})
export class HasCustomDataPipe implements PipeTransform {
  transform(
    customDataReport: DprActivityCustomDataReport[],
    inlineCustomData: DprActivityInlineCustomDataReport[]
  ): boolean {
    if (!customDataReport.length) {
      return false;
    }

    const inlineCustomDataIds = inlineCustomData.map((cd) => cd.id);

    return customDataReport.some(
      (cd) => !inlineCustomDataIds.includes(cd.customDataId)
    );
  }
}
